module.exports = __webpack_public_path__ + "img/rank1.184eb88c.png";